export default "__VITE_ASSET__16a981e4__"